import { Buffer } from 'buffer'

const g = globalThis

g.Buffer = Buffer
if (!g.global) g.global = g
